import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Button, Input, Label } from '@ipc/ipc-components';
import {
  getData,
  getColumns, getIsLoading,
} from '../redux/selectors/RouteModificationTransactionsSelectors';
import ListTable from '../../../../../common/tables/ListTable';
import TableDefinitions from '../../../../../common/TableDefinitions';
import { tableLoadData } from '../../../../../common/tables/actions/ListTableActions';
import { getAssetType } from '../../../../../common/asset-types/redux/selectors/AssetTypesSelectors';
import { getClickedRowOnTable } from '../../../../../common/tables/reducers/selectors/ListTableSelectors';
import RouteModificationTransactionsHistoryContainer from '../../transactions-history/route-modification/containers/RouteModificationTransactionsHistoryContainer';
import { TransactionsStyle } from '../../component/Transactions.styles';
import downloadTypes from '../../../../../common/tables/excel/DownloadTypes';

function getTableDownloadTemplate(appContext) {
  switch (appContext) {
  case 'tray':
  case 'bag':
    return 'ROUTE_MODIFICATION_TRANSACTIONS_FOR_TRAY_AND_BAG';
  case 'pallet':
  default:
    return 'ROUTE_MODIFICATION_TRANSACTIONS';
  }
}

class RouteModificationTransactionsContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedDayCount: 10,
    };
    this.clickApplyButton = this.clickApplyButton.bind(this);
    this.props.tableLoadData(
      {
        tableId: 'ROUTE_MODIFICATION_TRANSACTIONS',
      },
      this.props.appContext.appContext,
      {
        impcCode: this.props.clickedRow.impc,
        selectedDays: this.state.selectedDayCount,
      },
    );
  }

  componentDidUpdate(prevProps) {
    if (this.props.clickedRow !== prevProps.clickedRow) {
      this.props.tableLoadData(
        {
          tableId: 'ROUTE_MODIFICATION_TRANSACTIONS',
        },
        this.props.appContext.appContext,
        {
          impcCode: this.props.clickedRow.impc,
          selectedDays: this.state.selectedDayCount,
        },
      );
    }
  }

  enterPressed = (e) => {
    const code = e.keyCode || e.which;
    if (code === 13) {
      this.clickApplyButton();
    }
  }

  handleChange(e) {
    this.setState({
      selectedDayCount: e.target.value,
    });
  }

  clickApplyButton() {
    this.props.tableLoadData({ tableId: 'ROUTE_MODIFICATION_TRANSACTIONS' }, this.props.appContext.appContext, { impcCode: this.props.clickedRow.impc, numberOfDays: this.state.selectedDayCount });
  }

  render() {
    const {
      appContext: { appContext },
    } = this.props;
    return (
      <TransactionsStyle>
        <Label>
          Show transactions for the last
          <Input
            className="last-day-input"
            value={this.state.selectedDayCount}
            onChange={(e) => this.handleChange(e)}
            onKeyPress={this.enterPressed}
          />
          days
        </Label>
        <Button className="action-buttons" onClick={this.clickApplyButton}>
          Apply
        </Button>
        <ListTable
          listId={TableDefinitions.ROUTE_MODIFICATION_TRANSACTIONS.id}
          loading={this.props.isLoading}
          columns={this.props.columns}
          data={this.props.data}
          keyField="id"
          selectCheckbox
          downloadType={downloadTypes.EXCEL}
          downloadFileTemplate={getTableDownloadTemplate(appContext)}
          downloadFileAs="ROUTE_MODIFICATION_TRANSACTIONS"
          getSubComponentProps={(row) => (
            <div style={{ padding: '20px' }}>
              <RouteModificationTransactionsHistoryContainer
                row={row}
              />
            </div>
          )}
        />
      </TransactionsStyle>
    );
  }
}

function mapStateToProps(state) {
  return {
    data: getData(state),
    columns: getColumns(state),
    appContext: getAssetType(state),
    clickedRow: getClickedRowOnTable(state),
    isLoading: getIsLoading(state),
  };
}

RouteModificationTransactionsContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  columns: PropTypes.arrayOf(PropTypes.object),
  appContext: PropTypes.objectOf(PropTypes.string),
  tableLoadData: PropTypes.func,
  clickedRow: PropTypes.objectOf(PropTypes.shape),
  isLoading: PropTypes.bool,
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
  tableLoadData,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(RouteModificationTransactionsContainer);
